import { render, staticRenderFns } from "./Aterisk.vue?vue&type=template&id=5672aaae&scoped=true"
import script from "./Aterisk.vue?vue&type=script&lang=ts"
export * from "./Aterisk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5672aaae",
  null
  
)

export default component.exports